/**
 * Live search analytics for live Shoptified theme.
 * Does not change search UI or ranking — listen + beacon only.
 *
 * Search events fire on commit (form submit / /search page),
 * not on every keystroke or predictive click. Typing still updates
 * last-query context for click/ATC.
 */
(function () {
  "use strict";
  if (window.__lzLiveSearchAnalytics) return;
  window.__lzLiveSearchAnalytics = true;

  var EVENTS_URL =
    "https://lizzard-shopify-search.vercel.app/api/search-events";
  var SOURCE = "live-native";
  var SID_KEY = "lz_live_search_sid";
  var SID_COOKIE = "lz_live_search_sid";
  var ATC_CTX_KEY = "lz_live_search_atc_ctx";
  var LAST_Q_KEY = "lz_live_search_last_q";
  var ATC_CTX_TTL_MS = 30 * 60 * 1000;
  var lastLoggedQ = "";
  var lastLoggedAt = 0;
  /** Same query within this window is not re-sent (covers Enter+submit doubles). */
  var SEARCH_DEDUPE_MS = 120000;
  var lastClickKey = "";
  var lastClickAt = 0;
  var CLICK_DEDUPE_MS = 1000;
  var lastAtcKey = "";
  var lastAtcAt = 0;
  var ATC_DEDUPE_MS = 1000;
  /** Enter without a following submit (rare) — fallback commit. */
  var pendingEnterQ = "";
  var pendingEnterTimer = 0;

  function normalize(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function readCookie(name) {
    try {
      var m = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/[$()*+.?[\\\]^{|}]/g, "\\$&") + "=([^;]*)")
      );
      return m ? decodeURIComponent(m[1]) : "";
    } catch (e) {
      return "";
    }
  }

  function writeCookie(name, value) {
    try {
      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        "; path=/; SameSite=Lax; max-age=86400";
    } catch (e) {}
  }

  function getSid() {
    try {
      var existing =
        sessionStorage.getItem(SID_KEY) ||
        localStorage.getItem(SID_KEY) ||
        readCookie(SID_COOKIE);
      if (existing) {
        try {
          sessionStorage.setItem(SID_KEY, existing);
        } catch (e1) {}
        try {
          localStorage.setItem(SID_KEY, existing);
        } catch (e2) {}
        writeCookie(SID_COOKIE, existing);
        return existing;
      }
      var sid =
        "l" +
        Math.random().toString(36).slice(2, 10) +
        Date.now().toString(36);
      try {
        sessionStorage.setItem(SID_KEY, sid);
      } catch (e3) {}
      try {
        localStorage.setItem(SID_KEY, sid);
      } catch (e4) {}
      writeCookie(SID_COOKIE, sid);
      return sid;
    } catch (e) {
      return "";
    }
  }

  function rememberLastQ(q) {
    try {
      sessionStorage.setItem(LAST_Q_KEY, q);
    } catch (e) {}
  }

  function readLastQ() {
    try {
      return sessionStorage.getItem(LAST_Q_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function rememberAtcContext(q, handle) {
    try {
      sessionStorage.setItem(
        ATC_CTX_KEY,
        JSON.stringify({
          q: q,
          handle: handle || "",
          ts: Date.now(),
        })
      );
    } catch (e) {}
  }

  function readAtcContext() {
    try {
      var raw = sessionStorage.getItem(ATC_CTX_KEY);
      if (!raw) return null;
      var ctx = JSON.parse(raw);
      if (!ctx || !ctx.q || !ctx.ts) return null;
      if (Date.now() - ctx.ts > ATC_CTX_TTL_MS) {
        sessionStorage.removeItem(ATC_CTX_KEY);
        return null;
      }
      return ctx;
    } catch (e) {
      return null;
    }
  }

  function clearAtcContext() {
    try {
      sessionStorage.removeItem(ATC_CTX_KEY);
    } catch (e) {}
  }

  function themeId() {
    try {
      return (
        (window.Shopify &&
          Shopify.theme &&
          Shopify.theme.id != null &&
          String(Shopify.theme.id)) ||
        ""
      );
    } catch (e) {
      return "";
    }
  }

  function send(payload) {
    try {
      var q = normalize(payload.q);
      if (!q || q.length < 2) return;
      var body = {
        type: payload.type || "search",
        q: q,
        source: SOURCE,
        sid: getSid(),
        themeId: themeId(),
        ts: new Date().toISOString(),
      };
      if (payload.type === "search") {
        body.resultCount =
          typeof payload.resultCount === "number" ? payload.resultCount : 0;
        body.zeroResult = !body.resultCount;
      }
      if (payload.handle) body.handle = String(payload.handle).slice(0, 120);
      if (payload.position >= 1) body.position = payload.position;
      var json = JSON.stringify(body);
      if (window.fetch) {
        fetch(EVENTS_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: json,
          keepalive: true,
          mode: "cors",
          credentials: "omit",
        }).catch(function () {});
        return;
      }
      if (navigator.sendBeacon) {
        navigator.sendBeacon(
          EVENTS_URL,
          new Blob([json], { type: "text/plain;charset=UTF-8" })
        );
      }
    } catch (e) {
      /* never break storefront */
    }
  }

  function countPredictiveProducts() {
    try {
      var roots = document.querySelectorAll(
        "[data-predictive-search], .t4s-search-header__form-wrap, #t4s-search-hidden, .t4s-drawer__search, .predictive-search"
      );
      var best = 0;
      for (var i = 0; i < roots.length; i++) {
        var n = roots[i].querySelectorAll('a[href*="/products/"]').length;
        if (n > best) best = n;
      }
      return best;
    } catch (e) {
      return 0;
    }
  }

  /** Commit a search once per query within SEARCH_DEDUPE_MS (always, even force). */
  function logSearch(rawQ, resultCount) {
    var q = normalize(rawQ);
    if (!q || q.length < 2) return;
    var now = Date.now();
    if (q === lastLoggedQ && now - lastLoggedAt < SEARCH_DEDUPE_MS) return;
    lastLoggedQ = q;
    lastLoggedAt = now;
    rememberLastQ(q);
    var count =
      typeof resultCount === "number" ? resultCount : countPredictiveProducts();
    send({
      type: "search",
      q: q,
      resultCount: count,
    });
  }

  function isSearchInput(el) {
    if (!el || el.tagName !== "INPUT") return false;
    if (el.name === "q") return true;
    if (el.getAttribute && el.getAttribute("data-input-search") != null)
      return true;
    if (el.type === "search") return true;
    if (
      el.classList &&
      (el.classList.contains("t4s-search-header__input") ||
        el.classList.contains("search__input"))
    )
      return true;
    return false;
  }

  function isSearchForm(form) {
    if (!form || form.tagName !== "FORM") return false;
    if (form.matches && form.matches("[data-frm-search]")) return true;
    if (form.getAttribute && form.getAttribute("data-frm-search") != null)
      return true;
    var action = String(form.getAttribute("action") || form.action || "");
    if (/\/search/i.test(action)) return true;
    if (
      form.closest &&
      form.closest(
        "[data-predictive-search], .t4s-search-header__form-wrap, .t4s-drawer__search, #t4s-search-hidden"
      )
    )
      return true;
    return false;
  }

  function clearPendingEnter() {
    pendingEnterQ = "";
    if (pendingEnterTimer) {
      clearTimeout(pendingEnterTimer);
      pendingEnterTimer = 0;
    }
  }

  function bindInputs() {
    // Typing only updates context for click/ATC — does not emit search events
    document.addEventListener(
      "input",
      function (ev) {
        var el = ev && ev.target;
        if (!isSearchInput(el)) return;
        var q = normalize(el.value);
        if (q.length >= 2) rememberLastQ(q);
      },
      true
    );

    // Enter: prefer form submit as the single commit path. If no submit follows
    // (theme prevented it without firing submit), fall back after a short delay.
    document.addEventListener(
      "keydown",
      function (ev) {
        if (ev.key !== "Enter") return;
        var el = ev.target;
        if (!isSearchInput(el)) return;
        var q = normalize(el.value);
        if (!q || q.length < 2) return;
        clearPendingEnter();
        pendingEnterQ = q;
        pendingEnterTimer = setTimeout(function () {
          if (pendingEnterQ) {
            logSearch(pendingEnterQ);
            pendingEnterQ = "";
          }
          pendingEnterTimer = 0;
        }, 120);
      },
      true
    );

    document.addEventListener(
      "submit",
      function (ev) {
        try {
          var form = ev.target;
          if (!isSearchForm(form)) return;
          var input =
            form.querySelector("[data-input-search]") ||
            form.querySelector('input[name="q"]') ||
            form.querySelector('input[type="search"]');
          if (!input) return;
          clearPendingEnter();
          logSearch(input.value);
        } catch (e) {}
      },
      true
    );
  }

  function handleFromUrl(href) {
    try {
      var m = String(href || "").match(/\/products\/([^\/?#]+)/i);
      return m ? decodeURIComponent(m[1]) : "";
    } catch (e) {
      return "";
    }
  }

  function isSearchContextLink(link) {
    if (!link || !link.closest) return false;
    if (
      link.closest(
        "[data-predictive-search], #t4s-search-hidden, .t4s-drawer__search, .predictive-search, .t4s-search-header__form-wrap"
      )
    )
      return true;
    if (
      link.closest(
        ".t4s-section-main-search, [data-search-results], .template-search"
      )
    )
      return true;
    return false;
  }

  function currentSearchInputValue() {
    try {
      var el =
        document.activeElement && isSearchInput(document.activeElement)
          ? document.activeElement
          : document.querySelector(
              'input[name="q"], [data-input-search], input[type="search"], .t4s-search-header__input, .search__input'
            );
      return el && el.value ? normalize(el.value) : "";
    } catch (e) {
      return "";
    }
  }

  function bindClicks() {
    document.addEventListener(
      "click",
      function (ev) {
        try {
          var link =
            ev.target && ev.target.closest
              ? ev.target.closest('a[href*="/products/"]')
              : null;
          if (!link) return;
          var q = currentSearchInputValue() || normalize(readLastQ());
          if (!q) return;
          if (!isSearchContextLink(link) && !/\/search/.test(location.pathname))
            return;
          var handle = handleFromUrl(link.getAttribute("href") || "");
          var key = q + "|" + handle;
          var now = Date.now();
          if (key === lastClickKey && now - lastClickAt < CLICK_DEDUPE_MS) return;
          lastClickKey = key;
          lastClickAt = now;
          rememberLastQ(q);
          // Do NOT log a search on click — prefix noise while typing.
          send({
            type: "click",
            q: q,
            handle: handle,
            position: 1,
          });
          rememberAtcContext(q, handle);
        } catch (e) {}
      },
      true
    );
  }

  function sendAtcOnce(ctx) {
    if (!ctx || !ctx.q) return;
    var key = normalize(ctx.q) + "|" + String(ctx.handle || "");
    var now = Date.now();
    if (key === lastAtcKey && now - lastAtcAt < ATC_DEDUPE_MS) {
      clearAtcContext();
      return;
    }
    lastAtcKey = key;
    lastAtcAt = now;
    send({
      type: "atc",
      q: ctx.q,
      handle: ctx.handle || "",
    });
    clearAtcContext();
  }

  function bindAtc() {
    document.addEventListener(
      "submit",
      function (ev) {
        try {
          var form = ev.target;
          if (!form || !form.action) return;
          if (String(form.action).indexOf("/cart/add") === -1) return;
          var ctx = readAtcContext();
          if (!ctx) return;
          sendAtcOnce(ctx);
        } catch (e) {}
      },
      true
    );

    if (!window.fetch) return;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      var method =
        (init && init.method) ||
        (typeof input !== "string" && input && input.method) ||
        "GET";
      var p = origFetch.apply(this, arguments);
      try {
        if (
          url &&
          /\/cart\/add(\.js)?/i.test(String(url)) &&
          String(method).toUpperCase() === "POST"
        ) {
          p.then(function (res) {
            if (!res || !res.ok) return;
            var ctx = readAtcContext();
            if (!ctx) return;
            sendAtcOnce(ctx);
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  function logSearchPage() {
    try {
      if (!/\/search/.test(location.pathname)) return;
      var params = new URLSearchParams(location.search || "");
      var q = params.get("q") || "";
      if (!q) return;
      var count = document.querySelectorAll(
        'body.template-search a[href*="/products/"], .template-search a[href*="/products/"], .t4s-main-collection-search a[href*="/products/"], .t4s-section-main-search a[href*="/products/"]'
      ).length;
      logSearch(q, count);
    } catch (e) {}
  }

  function init() {
    bindInputs();
    bindClicks();
    bindAtc();
    logSearchPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
